var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopulationDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 46,
    viewBox: "0 0 55 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "113.5%",
    height: "113.2%",
    x: "-6.8%",
    y: "-6.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    filter: "url(#a)",
    opacity: 0.7,
    transform: "translate(12 -110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.32 122.4c0 .42-.28.7-.7.7h-8.4c-.42 0-.7-.28-.7-.7 0-.42.28-.7.7-.7h8.4c.28 0 .7.28.7.7zM16.154 126.423c2.288 0 4.038-1.75 4.038-4.038 0-2.289-1.75-4.039-4.038-4.039-2.289 0-4.039 1.75-4.039 4.039 0 2.288 1.75 4.038 4.039 4.038zm0-6.73a2.7 2.7 0 0 1 2.692 2.692 2.7 2.7 0 0 1-2.692 2.692 2.7 2.7 0 0 1-2.692-2.692c0-1.481 1.076-2.693 2.692-2.693zm-9.423 5.384c2.288 0 4.038-1.75 4.038-4.039 0-2.288-1.75-4.038-4.038-4.038-2.289 0-4.039 1.75-4.039 4.038 0 2.289 1.75 4.039 4.039 4.039zm0-6.73a2.7 2.7 0 0 1 2.692 2.691 2.7 2.7 0 0 1-2.692 2.693 2.7 2.7 0 0 1-2.693-2.693c0-1.48 1.077-2.692 2.693-2.692zm13.461 10.768a6.921 6.921 0 0 0-4.038-1.346c-1.48 0-2.962.539-4.039 1.346-1.211-1.615-3.23-2.692-5.384-2.692-3.77 0-6.731 2.962-6.731 6.73v3.366c0 1.077.942 2.02 2.02 2.02h.672v6.057c0 1.077.943 2.02 2.02 2.02H8.75c1.077 0 2.02-.943 2.02-2.02v-3.5c.268.135.403.135.672.135h.673v7.404c0 1.077.943 2.019 2.02 2.019h4.038c1.077 0 2.02-.942 2.02-2.02v-7.403h.672c1.08 0 2.015-.245 2.015-1.278v-4.248c0-2.551-.579-4.804-2.688-6.59zM9.423 134.5v10.096c0 .404-.27.673-.673.673H4.712c-.404 0-.674-.269-.674-.673v-6.058c0-.807-.538-1.346-1.346-1.346H2.02c-.404 0-.673-.269-.673-.673v-3.365c0-2.962 2.423-5.385 5.385-5.385 1.884 0 3.365.943 4.442 2.289-1.211 1.211-1.75 2.692-1.75 4.442zm12.115 4.712c0 .403-.269.673-.673.673h-.673c-.807 0-1.346.538-1.346 1.346v7.404c0 .403-.27.673-.673.673h-4.038c-.404 0-.673-.27-.673-.673v-7.404c0-.808-.539-1.346-1.347-1.346h-.673c-.404 0-.673-.27-.673-.673V134.5c0-2.962 2.423-5.385 5.385-5.385 2.961 0 5.384 2.423 5.384 5.385v4.712z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationDown);
export default __webpack_public_path__ + "static/media/population_down.ebe3ac88b4761fb97e9ae450f9e7e21a.svg";
export { ForwardRef as ReactComponent };